import { combineReducers } from 'redux';

import sistema from './sistema/combineReducers';
import localidade from './localidade/combineReducers';

export default combineReducers({
	sistema,
	localidade,
});
